import React, { Component } from 'react'
import { apiProcess } from '../../api/api.js'
import { withRouter } from "react-router-dom"
import * as Cookies from "js-cookie";

class GetUserReferralInfo extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error: false,
            hasReferralData: false,
            referralData: {}
        }
    }

    componentDidMount() {
        this.getUserReferralInfo()
    }

    getUserReferralInfo = () => {

        let userID = Cookies.get('userID')

        if(!userID) {
            return false
        }

        const apiURL = 'users/' + userID
        const data = false

        apiProcess(apiURL, data, 'public-profile', this.props.referralsDescription).then(function(responseData) {
            
            this.setState({
                loading: false,
                error: false,
                hasReferralData: true,
                referralData: {
                    referral_code : responseData.referral_code,
                    first_name: responseData.user_first_name,
                    avatar: responseData.user_avatar_cloudinary_public_id
                }
            })

        }.bind(this)).catch(function(responseData) {

            this.setState({
                    loading: false,
                    error: 'Sorry we have an error.', //go back and parse this out more.
                    hasReferralData: false,
                    referralData: {}
                })
        }.bind(this));
    }
    render() {

        const { loading, error, hasReferralData, referralData } = this.state
        return ( <React.Fragment> {
                this.props.render({
                    refLoading: loading,
                    getRefInfo: this.getUserReferralInfo,
                    refError : error,
                    hasRefData : hasReferralData,
                    refData : referralData,
                })
            } </React.Fragment>
        )
    }
}


export default withRouter(GetUserReferralInfo)

GetUserReferralInfo.defaultProps = {
    referralDescription: 'Get Logged in User Referral Information',
}